import * as api from '@utils/api'

export function mapFranchiseesToOptions(
  items: MCDC.API.IFranchiseeListItem[] = []
): MCDC.Props.IOption[] {
  return items.map((entry) => ({
    label: entry.city ? `${entry.name} (${entry.city})` : entry.name,
    value: entry.locationId,
  }))
}

export async function searchFranchiseeOptions(
  query: string
): Promise<MCDC.Props.IOption[]> {
  const items = await api.searchFranchiseeList(query)
  return mapFranchiseesToOptions(items)
}

export async function getFranchiseeByLocationId(
  locationId?: string
): Promise<MCDC.API.IFranchiseeDetail | undefined> {
  if (!locationId) return undefined
  const response = await api.getFranchiseeDetail(locationId)
  return response?.data
}
